import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_SPEEDINGS } from "../../../../common/constants/modules"

export const SpeedingsDesktopRoutes = () => {
    const { getParams } = useUrlParams()

    const speedingsRoutes = useMemo(() => {
        const searchParams = getParams()

        return [
            {
                path: "/",
                element: <>
                    <MapAdapterBoundingBox module={API_MODULE_SPEEDINGS} />
                    <SegmentSelectListener />
                </>,
            },
            {
                path: "/:road",
                element: <>
                    <MapAdapterRoad module={API_MODULE_SPEEDINGS} />
                    <DetailSegmentSelectListener />
                </>,
            },
            {
                path: "/:road/*",
                element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
            },
        ]
    }, [getParams])

    return useRoutes(speedingsRoutes)
}